// Mock data for Code Voiture - duplicate of Code 2 Roues structure, adapted for car license

export const navigation = [
  { label: 'Formation', href: '#formation', dot: true },
  { label: 'Tutos vidéo', href: '#tutos', dot: true },
  { label: 'Magazine', href: '#magazine', dot: true },
  { label: 'Mon journal', href: '#journal' },
  { label: 'Toutes les révisions', href: '#revisions' },
  { label: 'Plus', href: '#plus', dropdown: true },
];

export const announcement = {
  badge: 'ONISR · France métropolitaine',
  date: 'Baromètre mai 2026',
  text: 'Mai 2026 : 303 tués sur les routes (+7 % vs mai 2025) · Cyclistes +12 · Piétons +7 · Autoroute +17. Cumul 2026 : 1 262 tués (+8 %)',
  cta: "Voir le décryptage complet →",
  href: '/onisr-mai-2026',
};

export const newWayCard = {
  badge: 'Formation',
  title: 'Une façon différente de réviser.',
  description: 'Découvre nos **31 enquêtes magazine** + **9 dossiers ETG** : témoignages, statistiques, cas réels — sans chrono, sans score. Tu apprends en lisant, à ton rythme.',
  stats: '31 enquêtes + 9 dossiers magazine',
  cta: 'Découvrir',
};

export const campaign = {
  badge: 'Campagne officielle',
  category: 'Sécurité routière · 2026',
  title: 'Au volant, ne soyez pas victime de votre confiance',
  description: "68 % des automobilistes tués sont des conducteurs expérimentés, sur trajet quotidien, en zone rurale. La campagne 2026 s'adresse à eux.",
  duration: '2:15',
  decryptage: 'Décryptage Code Voiture',
  primaryCta: 'Lire le décryptage',
  secondaryCta: 'Voir le film',
  videoThumb: 'https://images.unsplash.com/photo-1465447142348-e9952c393450?w=1600&q=85&auto=format&fit=crop',
  credits: 'Film officiel · Sécurité routière',
  director: 'Réalisation : Alban Teurlay & Thierry Demaizière',
};

export const hero = {
  badge: 'À la une · Vol. 2026',
  title: ['La route', 'se partage.', 'La sécurité', 's\u2019apprend.'],
  primaryCta: 'Démarrer mon parcours',
  secondaryCta: 'Découvrir les 31 enquêtes',
  tagline: 'Conçu par des moniteurs ECSR — aligné sur le programme officiel 2026',
  free: '· 100 % gratuit · sans pub · sans tracking',
  bgImage: 'https://images.unsplash.com/photo-1504887764023-6f27056d186c?w=2400&q=85&auto=format&fit=crop',
};

export const tickerItems = [
  'Gratuit pour tous les candidats',
  'B · AAC · CS · B96 · B+E · BEA',
  'Programme officiel 2026 · 9 thèmes obligatoires',
  '9 dossiers ETG · 31 enquêtes magazine',
  'Sans pub, sans tracking, sans score',
  'Pensé par des moniteurs ECSR',
  'Épreuves Code · Conduite · Manœuvres',
];

export const modules = [
  { tag: 'OFFICIEL', title: 'Manœuvres', meta: '4 manœuvres · 32 min', img: 'https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=900&q=80&auto=format&fit=crop' },
  { tag: 'MAGAZINE', title: 'Apprendre', meta: '9 thèmes · Magazine pédagogique', img: 'https://images.unsplash.com/photo-1516862523118-a3724eb136d7?w=900&q=80&auto=format&fit=crop' },
  { tag: '', title: 'Circulation', meta: '32 min route ouverte', img: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=900&q=80&auto=format&fit=crop' },
  { tag: '', title: 'Trajectoires', meta: 'La courbe parfaite', img: 'https://images.unsplash.com/photo-1572401611152-cf63d874b019?w=900&q=80&auto=format&fit=crop' },
  { tag: '', title: 'Vérifications', meta: '12 points de contrôle', img: 'https://images.unsplash.com/photo-1630406144797-821be1f35d75?w=900&q=80&auto=format&fit=crop' },
];

export const guides = [
  { tag: 'À LA UNE', subtitle: 'Maîtriser le permis voiture', title: 'Passer le permis B en AAC ou CS', meta: '7 min · Sécurité routière 2026', img: 'https://images.unsplash.com/photo-1516862523118-a3724eb136d7?w=1600&q=85&auto=format&fit=crop', big: true },
  { tag: 'EXAMEN', subtitle: "Réussir l'examen pratique", title: "L'épreuve de conduite B", meta: '32 min · 4 manœuvres officielles', img: 'https://images.unsplash.com/photo-1578041262130-633307b3bfd6?w=1200&q=85&auto=format&fit=crop', big: true },
  { tag: 'Programme officiel · 9 thèmes', subtitle: '', title: 'Apprendre par thème', meta: 'Magazine pédagogique · 9 dossiers ETG', img: '', themes: true },
  { tag: '', subtitle: 'Comprendre les trajectoires', title: 'La courbe parfaite', meta: '4 min · Sécurité virage', img: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=900&q=85&auto=format&fit=crop' },
  { tag: '', subtitle: "L'équipement qui sauve", title: 'Ceinture, airbag, ABS', meta: '5 min · 12 points de contrôle', img: 'https://images.unsplash.com/photo-1572401611152-cf63d874b019?w=900&q=85&auto=format&fit=crop' },
  { tag: '', subtitle: "Préparer l'ASR", title: 'ASSR 2 / BSR / Conduite accompagnée', meta: '7 min · Scolarité', img: 'https://images.unsplash.com/photo-1524645343120-a4ae9f7d4343?w=900&q=85&auto=format&fit=crop' },
];

export const maneuvers = [
  { n: '01', label: 'Manœuvre 01', title: 'Marche arrière', sub: 'En ligne droite', meta: 'Suivre une trajectoire · contrôler les angles morts' },
  { n: '02', label: 'Manœuvre 02', title: 'Demi-tour', sub: 'En 3 temps maximum', meta: 'Voie étroite · sans monter sur trottoir' },
  { n: '03', label: 'Manœuvre 03', title: 'Freinage d\u2019urgence', sub: '50 km/h min · zone signalée', meta: 'Distance de sécurité · maîtrise du véhicule' },
  { n: '04', label: 'Manœuvre 04', title: 'Stationnement', sub: 'En créneau ou bataille', meta: 'Reprise · entrée · sortie sans toucher' },
  { n: '05', label: 'Manœuvre 05', title: 'Démarrage en côte', sub: 'Frein à main · sans recul', meta: 'Coordination embrayage · accélérateur' },
  { n: '06', label: 'Manœuvre 06', title: 'Rangement', sub: 'Le long du trottoir', meta: 'Distance · clignotant · contrôle' },
];

export const competences = [
  { code: 'C1', title: 'Maîtriser', subtitle: 'Le maniement du véhicule', count: '12 sous-compétences' },
  { code: 'C2', title: 'Appréhender', subtitle: 'La route et la circulation', count: '8 sous-compétences' },
  { code: 'C3', title: 'Circuler', subtitle: 'En conditions difficiles', count: '11 sous-compétences' },
  { code: 'C4', title: 'Pratiquer', subtitle: 'Une conduite autonome', count: '7 sous-compétences' },
];

export const magazineIssues = [
  { n: 'N°1', title: 'La route', desc: 'Signalisation, types de voies, marquages au sol — décoder ce que le bitume te dit.' },
  { n: 'N°2', title: 'La circulation', desc: 'Les règles qui régissent ta cohabitation avec les autres véhicules.' },
  { n: 'N°3', title: 'Le conducteur', desc: 'Alcool, stupéfiants, fatigue, distraction — ce qui se passe vraiment dans ta tête.' },
  { n: 'N°4', title: 'Les autres usagers', desc: 'Le partage de la route en milieu urbain et rural — survivre à la diversité.' },
  { n: 'N°5', title: 'Notions diverses', desc: "Tout l'administratif que tu dois maîtriser pour rester dans les clous." },
  { n: 'N°6', title: 'La mécanique', desc: 'Pneus, freins, éclairage, transmission — la check-list de pré-trajet.' },
  { n: 'N°7', title: 'Les équipements', desc: 'Ceinture, airbag, ABS, ESP — la chaîne de sécurité passive et active.' },
  { n: 'N°8', title: "L'environnement", desc: 'Éco-conduite, bruit, pollution, ZFE — la voiture responsable du XXIe siècle.' },
  { n: 'N°9', title: 'Premiers secours', desc: 'PAS (Protéger / Alerter / Secourir) — les gestes vitaux à connaître.' },
];

export const featuredIssue = {
  badge: 'Numéro à la une',
  number: 'N°7/9 · Les équipements',
  title: 'Ceinture, airbag, ABS : la chaîne de sécurité',
  desc: "Tout sur les équipements de sécurité, du minimum légal à l'aide à la conduite (ADAS).",
  meta: ['12 min', 'Format magazine', '100 % gratuit'],
  cta: 'Lire le numéro',
};

export const enquetes = [
  { n: 'N°31', tag: 'À LA UNE', category: 'Enquête mécanique & sécurité', title: 'Pression pneus voiture : 0,3 bar de trop ou de moins, tu changes de voiture', desc: '63 % des automobilistes ne vérifient JAMAIS leurs pneus. Pourtant 0,3 bar change tout : trajectoire, freinage, éclatement.', meta: '7 min de lecture', img: 'https://images.unsplash.com/photo-1630406144797-821be1f35d75?w=1600&q=85&auto=format&fit=crop', big: true },
  { n: 'N°30', tag: '', category: '', title: 'Équipement voiture 2026 : ceinture, sièges enfants, ADAS — ce qui devient obligatoire (et ce qui change)', desc: '', meta: '8 min', img: 'https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=900&q=85&auto=format&fit=crop' },
  { n: 'N°29', tag: '', category: '', title: 'V-I-S : la règle de 3 lettres qui te garde en vie en virage', desc: '', meta: '9 min', img: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=900&q=85&auto=format&fit=crop' },
  { n: 'N°28', tag: '', category: '', title: "L'angle mort en voiture : la zone qui tue (et personne n'en parle assez)", desc: '', meta: '8 min', img: 'https://images.unsplash.com/photo-1589828155685-83225f7d91f3?w=900&q=85&auto=format&fit=crop' },
];

export const stats2024 = {
  source: 'Source : ONISR 2024',
  primary: '2 850 automobilistes tués en France (-3 % vs 2023)',
  secondary: '**51 %** des tués sur la route. 14 800 blessés graves (-4 %).',
  caption: "Les automobilistes représentent la moitié des tués sur la route. La vigilance et la formation sauvent des vies.",
};

export const meteo = {
  title: 'Météo conducteur',
  location: 'Localisation…',
  status: 'Chargement…',
};

export const motoGP = {
  title: 'F1 2026',
  label: 'Prochain Grand Prix · Round 9/24',
  date: 'J-4',
  month: '20 juin',
  flag: '🇪🇸',
  country: 'Espagne',
  city: 'Barcelona',
  cta: 'Calendrier complet',
};

export const articleMoment = {
  badge: 'Conseil ECSR',
  cat: 'Article du moment · Sécurité',
  read: '~ 4 min de lecture',
  title: 'Bien choisir son siège auto enfant',
  desc: "Norme **i-Size R129**, groupes 0+ à 3, sanctions, conseils d'installation et d'entretien : le guide ECSR pour ne pas se tromper.",
  cta: 'Lire l\u2019article',
  img: 'https://images.unsplash.com/photo-1578041262130-633307b3bfd6?w=1200&q=75&auto=format&fit=crop',
};

export const parcours = [
  { age: 'Dès 15 ans', label: 'AAC · Conduite accompagnée', img: 'https://images.unsplash.com/photo-1524645343120-a4ae9f7d4343?w=1200&q=75&auto=format&fit=crop' },
  { age: 'Dès 18 ans', label: 'B · Permis voiture', img: 'https://images.unsplash.com/photo-1516862523118-a3724eb136d7?w=1200&q=75&auto=format&fit=crop' },
  { age: 'Dès 18 ans', label: 'BEA · Boîte automatique', img: 'https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=1200&q=75&auto=format&fit=crop' },
  { age: 'Extension B', label: 'B96 · Remorque légère', img: 'https://images.unsplash.com/photo-1572401611152-cf63d874b019?w=1200&q=75&auto=format&fit=crop' },
  { age: '7h pratique', label: 'CS · Conduite supervisée', img: 'https://images.unsplash.com/photo-1630406144797-821be1f35d75?w=1200&q=75&auto=format&fit=crop' },
  { age: 'Pro', label: 'B+E · Remorque lourde', img: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=1200&q=75&auto=format&fit=crop' },
];

export const stats = [
  { value: '9', label: 'Dossiers ETG' },
  { value: '31', label: 'Enquêtes magazine' },
  { value: '100%', label: 'Gratuit, à vie' },
];

export const reasons = [
  { title: 'Correction IA', desc: 'Explication pédagogique à chaque question.' },
  { title: 'Par thème', desc: 'Les 9 thèmes officiels expliqués en magazine, à ton rythme.' },
  { title: 'Approche terrain', desc: 'Pensé par des moniteurs voiture agréés ECSR.' },
];

export const threePaths = [
  { tag: 'Élève', title: 'Je prépare mon permis voiture', desc: 'B, AAC, CS, BEA, B96, B+E', href: '#eleve' },
  { tag: 'Enseignant certifié', title: 'J\u2019anime mes séances terrain', desc: 'Séance live, plateau, fiches REMC, jury', href: '#enseignant' },
];

export const footerLinks = {
  apprendre: ['Code · 9 thèmes', 'Manœuvres', 'Circulation', 'Trajectoires', 'Vérifications'],
  ressources: ['Magazine', '31 enquêtes', 'Mon livret', 'Tutos vidéo', 'Annuaire des auto-écoles', 'Livret AM (flipbook)', 'FAQ'],
  audiences: ['Élève', 'Enseignant ECSR'],
  legal: ['Mentions légales', 'CGU', 'Confidentialité', 'Cookies', 'Contact', 'Signaler une erreur', 'Nos plateformes'],
};
;
